module.exports = __webpack_public_path__ + "img/空白（同版心宽）.ce33ec50.jpg";